import { Table } from 'antd'
import { createContext, FC } from 'react'
import styled from 'styled-components'
import TableWrapper from '../../../../components/table-wrapper/table-wrapper'
import { useGetRewindQueueEntriesQuery } from '../../../../store/api/rewind-queue-entries-api'
import Machine from '../../../../types/api/machine'
import RewindQueueEntry from '../../../../types/api/rewind-queue-entry'
import { columns } from './columns'
import { getQueryParams } from './helpers/get-query-params'
import { isRewindJobPaused } from './helpers/rewind-job-helpers'

export const OneRewinderMachineScheduleContext = createContext<RewindQueueEntry[]>([])

const StyledTableWrapper = styled(TableWrapper)`
    .rewind-job-paused td {
        background-color: #fffbe6;
    }
`

interface OneRewinderMachineScheduleProps {
    machine: Machine
}

const OneRewinderMachineSchedule: FC<OneRewinderMachineScheduleProps> = ({ machine }) => {
    const queryParams = getQueryParams(machine)
    const { data } = useGetRewindQueueEntriesQuery(queryParams, {
        pollingInterval: 5000,
        skipPollingIfUnfocused: true,
    })
    const dataSource = data?.data || []

    return (
        <OneRewinderMachineScheduleContext.Provider value={dataSource}>
            <StyledTableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                filtersSummaryHeight={0}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey='documentId'
                    size='small'
                    rowClassName={record =>
                        isRewindJobPaused(record.rewind_job) ? 'rewind-job-paused' : ''
                    }
                />
            </StyledTableWrapper>
        </OneRewinderMachineScheduleContext.Provider>
    )
}

export default OneRewinderMachineSchedule
